export type StorageType = "session" | "local";

export function getStorageSafely(storageType: StorageType) {
  try {
    return storageType === "session" ? sessionStorage : localStorage;
  } catch {
    return null;
  }
}
